import { useEffect, useRef } from "react";
import { C } from "../../shared/theme";

const SHOWN_FOR_MS = 6000;

// "Added to Evening · Undo" along the bottom of the screen. It leaves on its own after a few seconds.
// The message is announced to screen readers. Without onUndo it is a plain message (a failed save).
// takeFocus moves keyboard focus to Undo when the control that was pressed has gone.
export function UndoToast({ message, onUndo, onDone, takeFocus }) {
  const undoRef = useRef(null);
  useEffect(() => { if (takeFocus) undoRef.current?.focus(); }, [takeFocus]);
  useEffect(() => {
    const timer = setTimeout(onDone, SHOWN_FOR_MS);
    return () => clearTimeout(timer);
  }, [message, onDone]);

  return (
    <div role={onUndo ? "status" : "alert"} style={{ position: "fixed", left: 16, right: 16, bottom: 156, zIndex: 400, maxWidth: 520, margin: "0 auto", display: "flex", alignItems: "center", gap: 12, padding: onUndo ? "4px 4px 4px 16px" : "4px 16px", minHeight: 52, borderRadius: 12, background: C.text, color: C.bg, boxShadow: C.shadowMd }}>
      <span style={{ flex: 1, minWidth: 0, fontSize: 15, fontWeight: 600, lineHeight: 1.35 }}>{message}</span>
      {onUndo && <button ref={undoRef} onClick={onUndo}
        style={{ minHeight: 44, padding: "0 14px", borderRadius: 10, border: "none", background: "transparent", color: C.bg, fontSize: 15, fontWeight: 800, textDecoration: "underline", cursor: "pointer", fontFamily: "inherit" }}>
        Undo
      </button>}
    </div>
  );
}
